import React, { useEffect, useRef } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CheckoutPage from "../CheckoutPage/";
import { ModalTitle } from "../QueueIntegrationModal/panelKit";

const ContactModal = ({ open, onClose, Invoice, contactId, initialValues, onSave }) => {
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" scroll="paper">
      <ModalTitle
        title="Falta pouco!"
        subtitle="Confirme o plano, revise os dados e conclua o pagamento."
        onClose={handleClose}
      />
      <DialogContent>
        <CheckoutPage
          Invoice={Invoice}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
